module.exports = __webpack_public_path__ + "img/mag-turbine.0e8a38b4.png";